import apiPaths from '../api-paths';

export default {
  show({ id }) {
    return axios.get(`${ apiPaths.BOOKKEEPING }/work-parameters/${ id }`);
  },
  store({ workParameter }) {
    return axios.post(`${ apiPaths.BOOKKEEPING }/work-parameters/`, { workparameters: workParameter });
  },
  update({ workParameter }) {
    return axios.put(`${ apiPaths.BOOKKEEPING }/work-parameters/` + workParameter.id, { workparameters: workParameter });
  },
  showWorkParameterTypeByOriginal({ id }) {
    return axios.get(`${ apiPaths.BOOKKEEPING }/work-parameters-types/by-original/${ id }`);
  }
}
